import { useParams } from 'react-router-dom';
import type { UploadPortal, UploadPortalParams } from '@/types/upload';

/**
 * Auto-derive the current portal + route params from React Router.
 *
 * Convention in this codebase:
 *   - URL param `site`          → site type (medix, upsystem, ...)
 *   - URL param `clinicNumber`  → clinic number (only on clinic portal routes)
 *
 * The portal is inferred from which params are present. A caller can override
 * any field if automatic detection is not appropriate.
 */
export const useUploadPortal = (
  override?: Partial<{ portal: UploadPortal; siteType: string; clinicNumber: string }>,
): { portal: UploadPortal; params: UploadPortalParams } => {
  const routeParams = useParams<{ site?: string; clinicNumber?: string }>();

  const siteType = override?.siteType ?? routeParams.site ?? 'medix';
  const clinicNumber = override?.clinicNumber ?? routeParams.clinicNumber;

  const portal: UploadPortal =
    override?.portal ?? (clinicNumber ? 'clinic' : 'admin');

  return {
    portal,
    params: { siteType, clinicNumber },
  };
};
